<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    
    <div class="w-full">
        <p class="pb-2">
          <vs-button v-if="$store.state.dash.viewData.currentShowcasedIDs.length !== 0" class="w-full hidden md:flex md:w-64 mt-3 md:mt-0 md:float-right lg:mr-1" icon-pack="feather" icon-after icon="icon-plus" @click="() => {
              $router.push('/dash/showcase/setupwidget/choose')
            }">Create Widget</vs-button>          
          <Pagesubtitle
      subTitle="Install widgets on your website that elegantly showcase your best reviews & feedback."
    />
        </p>
      </div>     

  <div class="text-center py-10" v-if="!$store.state.dash.viewState.widgetsLoaded || !$store.state.dash.viewState.showcaseDataLoaded">
          <p class="mb-2">Loading showcase...</p>
          <div class="w-8 h-8 pt_loading inline-block"></div>
  </div>
  <div v-else>

    <vs-tabs class="mt-base" v-model="currentTab" >

      <vs-tab label="On Showcase" class="px-1 pt-base">
        <div class="flex flex-wrap justify-between items-center mb-4">
          <p class="text-light w-full md:w-auto mb-2 md:mb-0">Reviews and feedback you've selected to showcase.</p>
          <div class="flex items-center">
            <vs-button type="flat" icon-pack="feather" icon="icon-info" class="mr-2" @click="showExplainerModal = true">How to import reviews</vs-button>
            <vs-button icon-pack="feather" icon="icon-download" icon-after @click="optAddMore">Import Reviews</vs-button>
          </div>
        </div>

        <div v-if="!$store.state.dash.viewState.showcasedItemsLoaded" class="text-center py-10">
          <div class="w-8 h-8 pt_loading inline-block"></div>
          <p class="mt-2 text-light">Loading showcased items...</p>
        </div>

        <div v-else-if="showcasedItems.length === 0" class="text-center py-20">
          <h5>No items currently on showcase.</h5>
          <h1 class="my-10 mx-auto max-w-lg font-semibold">Add reviews or feedback to your showcase to display them in your widgets.</h1>
          <vs-button class="inline-block mt-4" size="large" @click="optAddMore">Import Reviews</vs-button>
        </div>

        <div v-else class="vx-row w-full mx-0">
          <div class="vx-col px-2 flex mb-base w-full md:w-1/2 lg:w-1/2 2xl:w-1/3" v-for="item in showcasedItems" :key="item.id">
            <vx-card class="w-full text-dark relative nohover pt_ple_shadow showcased-card">
              <div class="vx-row">
                <div class="vx-col w-1/2">
                  <vue-load-image v-if="itemView(item).profilePic">
                    <div slot="preloader" style="border-radius: 50%;" class="profiledown w-8 float-left mr-3">
                      <feather-icon icon="StarIcon" svgClasses="w-10 h-10 text-primary"></feather-icon>
                    </div>
                    <img slot="image" style="border-radius: 50%;" :src="itemView(item).profilePic" class="profiledown w-10 float-left"/>
                    <div slot="error" style="border-radius: 50%;" class="profiledown w-8 float-left mr-3">
                      <feather-icon icon="UserIcon" svgClasses="w-10 h-10 text-primary"></feather-icon>
                    </div>
                  </vue-load-image>
                  <div v-else style="border-radius: 50%;" class="profiledown w-8 float-left mr-3">
                    <feather-icon icon="UserIcon" svgClasses="w-10 h-10 text-primary"></feather-icon>
                  </div>
                  <p class="font-semibold">{{ itemView(item).author }}</p>
                  <p class="text-sm text-light">{{ itemView(item).dateDisplay }}</p>
                </div>
                <div class="vx-col w-1/2 text-right">
                  <img v-if="platformIcon(item.platform)" :src="platformIcon(item.platform)" class="w-5 inline-block mr-1 align-middle" />
                  <span class="text-sm text-light align-middle">{{ platformName(item.platform) }}</span>
                  <div class="mt-2">
                    <star-rating v-if="itemView(item).rating" class="inline-block" :rating="itemView(item).rating" :max-rating="itemView(item).ratingMax" :star-size="18" :read-only="true" :round-start-rating="false"></star-rating>
                  </div>
                </div>
              </div>
              <vs-divider/>
              <p v-if="itemView(item).title" class="font-semibold">{{ itemView(item).title.substr(0, 60) }}{{ itemView(item).title.length > 60 ? '...' : '' }}</p>
              <p v-if="itemView(item).body"><span class="text-xl font-bold italic inline-block mx-1">"</span><span v-html="itemView(item).body"></span><span class="text-xl font-bold italic inline-block mx-1">"</span></p>
              <div class="video showcased-video mt-2" v-if="itemView(item).videoURL && itemView(item).streamUID">
                <HLSVideoPlayer :src="itemView(item).videoURL" :options="{
                  controls: true,
                  autoplay: false,
                  preload: 'auto',
                }"/>
                <vs-button type="border" size="small" class="mt-1" @click="downloadVideo(itemView(item).answer)" icon-pack="feather" icon="icon-download" icon-after></vs-button>
                <img class="invisible" style="height: 0px !important" :src="itemView(item).videoThumbURL ? itemView(item).videoThumbURL : `https://customer-n548bbvvl783tp8n.cloudflarestream.com/${itemView(item).streamUID}/thumbnails/thumbnail.gif?time=1s&height=500&duration=4s`"/>
                <img class="invisible" style="height: 0px !important" :src="itemView(item).videoThumbURL ? itemView(item).videoThumbURL : `https://customer-n548bbvvl783tp8n.cloudflarestream.com/${itemView(item).streamUID}/thumbnails/thumbnail.jpg?time=0s&height=500`"/>
              </div>
              <p class="text-light" v-else-if="!itemView(item).body">(No text provided)</p>
              <vs-divider
                v-if="(item.taggedWith && item.taggedWith.length > 0) || $store.state.dash.viewData.currentWidgets.length > 0"
                class="my-3"
              />
              <div v-if="item.taggedWith && item.taggedWith.length > 0" class="mt-2 flex flex-wrap items-center">
                <span class="text-sm text-light font-semibold mr-2">Tags:</span>
                <vs-chip v-for="tag in item.taggedWith" :key="`${item.id}_${tag}`" color="primary" class="mr-1 mb-1">{{ tag }}</vs-chip>
              </div>
              <div v-if="$store.state.dash.viewData.currentWidgets.length > 0" class="mt-2 flex flex-wrap items-center">
                <span class="text-sm text-light font-semibold mr-2">On Widgets:</span>
                <template v-if="matchedWidgetsFor(item).length > 0">
                  <vs-chip
                    v-for="w in matchedWidgetsFor(item)"
                    :key="`${item.id}_w_${w.widgetID}`"
                    color="success"
                    class="mr-1 mb-1"
                  >{{ w.name }}</vs-chip>
                </template>
                <span v-else class="text-sm text-warning">
                  <feather-icon icon="AlertCircleIcon" svgClasses="w-4 h-4 inline align-middle mr-1"/>
                  Not on any widget — add a matching tag, or
                  <a href="" @click.prevent="currentTab = 1" class="text-primary">edit a widget</a>.
                </span>
              </div>
              <vs-divider class="my-3"/>
              <div class="showcased-card-actions flex flex-wrap items-center justify-between">
                <ShowcasedRowControls
                  :payload="buildShowcasePayload(item)"
                  :item="item"
                />
                <vs-button v-if="itemView(item).sourceUrl" :href="itemView(item).sourceUrl" target="_blank" color="primary" type="flat" icon-pack="feather" icon="icon-external-link" icon-after>Source</vs-button>
              </div>
            </vx-card>
          </div>
        </div>
      </vs-tab>

      <vs-tab label="Widgets" class="px-1 pt-base">
        <div v-if="$store.state.dash.viewData.currentWidgets.length > 0">
          <p class="text-center mb-5" v-if="widgetsLoading">Widgets are being prepared... This should take less than 30 seconds...</p>
      <div
        class="items-list-view mb-5"
        v-for="widget in $store.state.dash.viewData.currentWidgets"
        :key="widget.widgetID"
      >
        <div class="vx-card list-view-item overflow-hidden py-4 sm:py-0">
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-row item-details no-gutter relative">
              <div
                class="
                  py-6
                  px-10
                  vx-col
                  w-full
                  item-img-container
                  bg-white
                  md:flex
                  items-center
                  justify-between
                "
              >
                <span class="w-full my-4 block md:w-100 font-semibold text-lg">{{widget.name}}</span>
                <span class="w-full my-4 text-sm block md:mx-4 md:w-32">{{widget.type === 'generalnudge' ? 'Nudge' : ( widget.type === 'wallofproof' ? 'Wall of proof' : ( widget.type === 'infinitywall' ? 'Infinity Wall' : 'Carousel Slider'))}}</span>
                <div class="w-full my-4 block md:ml-10">
                  <span v-if="widget.showAllTags" >All tags</span>
                  <div v-else>
                    <span class="mr-2 inline-block" v-for="(tag,i) in widget.showOnlyTags" :key="tag">{{ tag }}{{ i === widget.showOnlyTags.length - 1 ? '' : ','}}</span>                    
                  </div>
                </div>
                <div class="flex flex-wrap w-full">
                  <vs-button class="mx-1 mt-2 lg:mt-0" type="border" icon-pack="feather" icon="icon-trash" @click="() => {
                      
                    currentWidgetToRemoveID = widget.widgetID
                    currentWidgetToRemoveName = widget.name
                    showSureRemoveWidget = true

                    }"></vs-button>
                  <vs-button class="mx-1 mt-2 lg:mt-0" type="border" @click="$router.push(`/dash/showcase/${widget.widgetID}`)">Install</vs-button>
                  <vs-button class="mx-1 mt-2 lg:mt-0" type="border" :disabled="widgetsLoading" @click="$router.push(`/dash/showcase/setupwidget/${widget.widgetID}`)">Edit</vs-button>
                  <vs-button class="mx-1 mt-2 lg:mt-0" @click="previewWidget(widget.widgetID, widget.type, widget.name)" :disabled="widgetsLoading">{{ widgetsLoading ? 'Loading...' : 'Preview' }}</vs-button>
                </div>                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$store.state.dash.viewData.currentShowcasedIDs.length !== 0 && $store.state.dash.viewData.currentWidgets.length === 0" class="py-10 text-center">
      <p class="font-semibold text-xl mt-base mb-4">You don't have any widgets. </p>
      <p class="mb-base">Choose one below to create a showcase widget for your website.</p>
    </div>
    <div
      v-if="$store.state.dash.viewData.currentShowcasedIDs.length === 0"
      class="text-center py-20"
    >
      <h5>No items currently on showcase.</h5>
      <h1 class="my-10 mx-auto max-w-lg font-semibold">
        Before you can create a widget, you need to add testimonials, feedback or
        reviews to your showcase.
      </h1>
      <h5 class="mx-auto max-w-lg mb-10">
        There are two ways to do it — choose one to get started:
      </h5>
      <vs-button
        @click="
          () => {
            $router.push('/dash/responses');
            $vs.notify({
              title: 'Select testimonials or feedback for showcase',
              text: 'Click on \'Showcase\' next to a testimonial or piece of feedback to add it to your showcase.',
              color: 'primary',
              time: 15000,
              iconPack: 'feather',
              icon: 'icon-info',
            });
          }
        "
        class="inline-block mt-2 mx-2"
        type="border"
        size="large"
        >Showcase Testimonials or Feedback</vs-button
      >
      <vs-button
        @click="optAddMore"
        class="inline-block mt-2 mx-2"
        type="border"
        size="large"
        >Showcase Reviews</vs-button
      >
    </div>
    <div class="my-10" v-else>
      <h5 class="my-4 mt-base">Create Widget</h5>
      <div class="vx-row">
        <div class="vx-col md:w-5/12">
          <p class="font-semibold text-xl mb-5">Wall of Proof</p>
          <img class="w-full rounded block" src="@/assets/images/misc/WOP.png" />
          <vs-button
            class="mt-5 w-full"
            type="border"
            @click="seeExample('wallofproof')"
            >See example</vs-button
          >
          <vs-button
            class="mt-2 mb-5 w-full"
            @click="optCreateWidget('wallofproof')"
            >Create widget</vs-button
          >
          <p class="mb-5">
            Embed a beautiful selection of reviews & feedback right into your
            page.
          </p>
        </div>
        <div class="vx-col md:w-5/12">
          <p class="font-semibold text-xl mb-5">Showcase Nudge</p>
          <img class="w-full rounded block" src="@/assets/images/misc/GN.png" />
          <vs-button
            class="mt-5 w-full"
            type="border"
            @click="seeExample('generalnudge')"
            >See example</vs-button
          >
          <vs-button
            class="mt-2 mb-5 w-full"
            @click="optCreateWidget('generalnudge')"
            >Create widget</vs-button
          >
          <p class="mb-5">
            Eloquently surface your best reviews & feedback in the bottom right
            or left corner of your site.
          </p>
        </div>
        <div class="vx-col md:w-5/12">
          <p class="font-semibold text-xl mb-5">Carousel Slider</p>
          <img class="w-full rounded block" src="@/assets/images/misc/carousel.png" />
          <vs-button
            class="mt-5 w-full"
            type="border"
            @click="seeExample('carousel')"
            >See example</vs-button
          >
          <vs-button
            class="mt-2 mb-5 w-full"
            @click="optCreateWidget('carousel')"
            >Create widget</vs-button
          >
          <p class="mb-5">
            Eloquently surface your best reviews & feedback in the bottom right
            or left corner of your site.
          </p>
        </div>
        <div class="vx-col md:w-5/12">
          <p class="font-semibold text-xl mb-5">Infinity Wall</p>
          <img class="w-full rounded block" src="@/assets/images/infinitywall.png" />
          <vs-button
            class="mt-5 w-full"
            type="border"
            @click="seeExample('infinitywall')"
            >See example</vs-button
          >
          <vs-button
            class="mt-2 mb-5 w-full"
            @click="optCreateWidget('infinitywall')"
            >Create widget</vs-button
          >
          <p class="mb-5">
            A full-width, ambient wall of testimonials that gently auto-scrolls
            in alternating directions — a living backdrop for your page.
          </p>
        </div>
      </div>
    </div>  
      </vs-tab>
      
      <vs-tab label="Domain Settings" class="px-1 pt-base">
        
        <div class="vx-row">
          <div class="vx-col w-full md:w-1/2">           
            <DomainSettings :domainSettingsUpdated="domainSettingsUpdated"/>
            <vs-alert      
      class="p-2 w-full mb-base rounded flex items-center text-dark"
      color="primary"
    >
      <div>
        <span>Your domain settings for showcase are shared accross all spaces. Different requirements? <a href="" @click.prevent="chatToUs">Talk to us</a></span>
      </div>
      
    </vs-alert> 
            <vs-button class="mt-4" size="large" @click="updateDomainSettings">Update Settings</vs-button>
            
          </div>
        </div>

      </vs-tab>
    </vs-tabs>

  </div>



    <SideSlide    
      v-if="showPreviewWidget" 
      @close="showPreviewWidget = false"
      size="large"
      >    
      <div>        
        <iframe class="w-full h-200 wpreview" style="height: 74vh;" :src="iframeSrc" ref="widgetpreviewframe"></iframe>
      </div>    
      <div class="flex justify-center">        
        <vs-button class="mx-1 w-64" type="border" icon-pack="feather" icon="icon-refresh-ccw" @click="refreshFrame">Refresh</vs-button>                
      </div>
      <p class="text-center mt-2 w-full">Widget not updated? Please give a minute before refreshing...</p>
    </SideSlide>

    <SideSlide
      v-if="showExampleWidget"
      @close="showExampleWidget = false"
      size="large"
      >
      <div>
        <iframe class="w-full h-200 wpreview" style="height: 74vh;" :src="exampleIframeSrc"></iframe>
      </div>
      <p class="text-center mt-2 w-full">This is an example showing demo content — your own widget will use your reviews &amp; testimonials.</p>
    </SideSlide>

    <SideSlide
      v-if="showSideSlide"
      @close="closeSideSlide"
    >
      <div v-if="timeSCreated - currentInstallWidgetData.timeCreatedS < 20" >
        <h3 class="text-center mt-2 mb-8">Widget Created!</h3>               
      </div>
      <div v-else class="text-center mt-2 mb-8">
        <h3>Widget Installation</h3>
        </div>
              
      <div v-if="currentInstallWidgetData.type === 'wallofproof' || currentInstallWidgetData.type === 'carousel' || currentInstallWidgetData.type === 'infinitywall'">
              
        <p class="my-4 font-medium"><span class="font-semibold">Step 1. </span>Copy and paste the below code snippet  <span class="font-semibold">right before the &lt;/body&gt; tag</span> in all HTML pages where you want to display your widget.</p>
        <div class="vx-card p-0">
          <div class="text-dark px-3 py-5 rounded italic w-full">
          <pre :id="`${currentInstallWidgetData.widgetID}code`" class="w-full bg-white block overflow-x-scroll p-0" >&lt;script&gt;
  //Feedback Link Showcase Widget "{{ currentInstallWidgetData.name }}":
  ! function(w, d){
    if (!w || !d) return false;    
    d.addEventListener("DOMContentLoaded", function(event) {
        var s = d.createElement('script');
        s.setAttribute('src','https://fbl.embedwidgets.com/{{
              currentInstallWidgetData.widgetID
            }}.js');
        d.body.appendChild(s);
      });
    }(window, document)
 &lt;/script&gt;</pre>      
        </div>        
        </div>
        <vs-button @click="copyCode(currentInstallWidgetData.widgetID, 'code')" type="border" class="w-full" icon-pack="feather" :icon="lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}code` ? '' : 'icon-copy'" icon-after>{{ lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}code` ? 'Copied!' : 'Copy' }}</vs-button>        
        <p class="mt-4 text-light">Remember to place this script <span class="font-bold">right above</span> the &lt;/body&gt; tag.</p>        
        <p class="my-4 font-medium"><span class="font-semibold">Step 2. </span>Copy and paste the below code snippet at the <span class="font-semibold">exact position</span> where you want your {{ currentInstallWidgetData.type === 'wallofproof' ? "Wall of Proof" : (currentInstallWidgetData.type === 'infinitywall' ? "Infinity Wall" : "Carousel") }} to be displayed.</p>
        <div class="vx-card p-0">
          <div class="text-dark px-3 py-5 rounded italic w-full">
          <pre :id="`${currentInstallWidgetData.widgetID}div`" class="w-full bg-white block overflow-x-scroll p-0">&lt;div class="fbl_w_{{currentInstallWidgetData.widgetID}}"&gt;&lt;/div&gt;</pre>          
        </div>        
        </div>
        <vs-button @click="copyCode(currentInstallWidgetData.widgetID, 'div')" type="border" class="w-full" icon-pack="feather" :icon="lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}div` ? '' : 'icon-copy'" icon-after>{{ lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}div` ? 'Copied!' : 'Copy' }}</vs-button>        
        <p class="my-4 font-medium">You can place more than one of these snippets anywhere on the page. The {{ currentInstallWidgetData.type === 'wallofproof' ? "Wall of Proof" : (currentInstallWidgetData.type === 'infinitywall' ? "Infinity Wall" : "Carousel") }} will be loaded in those position(s).</p>
      </div>
      <div v-else>

        <p class="my-4 font-medium">Copy and paste the below code snippet anywhere before the &lt;/body&gt; tag in all HTML pages where you want the widget to be displayed.</p>
        <div class="vx-card">
        <div class="text-dark px-5 py-3 rounded w-full">
          <pre :id="`${currentInstallWidgetData.widgetID}code`" class="w-full bg-white block overflow-x-scroll">&lt;script&gt;
  //Feedback Link Showcase Widget "{{ currentInstallWidgetData.name }}":
  ! function(w, d){
    if (!w || !d) return false;
    d.addEventListener("DOMContentLoaded", function(event) {
        var s = d.createElement('script');
        s.setAttribute('src','https://fbl.embedwidgets.com/{{
              currentInstallWidgetData.widgetID
            }}.js');
        d.body.appendChild(s);
    });
    }(window, document);
 &lt;/script&gt;</pre>
        </div>
        </div>      
        <vs-button @click="copyCode(currentInstallWidgetData.widgetID, 'code')" type="border" class="w-full" icon-pack="feather" :icon="lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}code` ? '' : 'icon-copy'" icon-after>{{ lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}code` ? 'Copied!' : 'Copy' }}</vs-button>        
      </div>     
    </SideSlide>

      <vs-popup class="holamundo" title="Remove widget" :active.sync="showSureRemoveWidget" @close="() => {
          showSureRemoveWidget = false
          removeText = ''
        }">
        <div class="con-vs-alert mt-3 con-vs-alert-danger">
          <h4 class="titlex vs-alert--title">Warning</h4>
          <div class="vs-alert text-lg">
            If you remove this widget, you will lose all settings, and it will cease working on your site(s).
          </div>
        </div>
        <vs-divider class="my-4"/>
        <p class="text-lg mb-2">
          If you're sure you want to remove the widget <span class="font-medium text-xl">"{{ currentWidgetToRemoveName }}"</span>, please type "remove" in the below textbox.</p>
        <vs-input placeholder="Type 'remove' to continue." v-model="removeText"/>
        <div class="overflow-auto mt-4">
          <vs-button class="float-right ml-1" @click="() => {
              removeWidget(currentWidgetToRemoveID)
              showSureRemoveWidget = false
              removeText = ''
            }" :disabled="removeText !== 'remove'">Remove</vs-button>
          <vs-button type="border" class="float-right" @click="() => {
            showSureRemoveWidget = false
            removeText = ''
          }">Cancel</vs-button>
        </div>
      </vs-popup>

      <import-reviews-modal v-model="showAddMoreModal" />

      <vs-popup class="holamundo import-reviews-explainer-popup" title="" :active.sync="showExplainerModal" @close="showExplainerModal = false">
        <import-reviews-alert :value="false" @input="onExplainerInstallClick" />
      </vs-popup>



  </div>
</template>

<script>


/*


   <vs-popup class="fullscreen-popup" title="Preview Widget" 
      :active.sync="showPreviewWidget" 
      @close="showPreviewWidget = false">
      <div>        
        <iframe class="w-full h-200 wpreview" style="height: 74vh;" :src="iframeSrc" ref="widgetpreviewframe"></iframe>
      </div>
      <div class="flex justify-center">
        <vs-button class="mx-1 w-64" type="border" @click="showPreviewWidget = false">Close</vs-button>        
        <vs-button class="mx-1 w-64" type="border" icon-pack="feather" icon="icon-refresh-ccw" @click="refreshFrame">Refresh</vs-button>                
      </div>
      <p class="text-center mt-2 w-full">Widget not updated? Please give a minute before refreshing...</p>
      </vs-popup>   

<vs-popup
      class="holamundo"
      size="large"
      title="Install Widget"
      :active.sync="showSideSlide"
      @close="
        () => {
          showSideSlide = false;
          $router.replace('/dash/showcase')
        }
      "
    >
      <div v-if="timeSCreated - currentInstallWidgetData.timeCreatedS < 20" >
        <h3 class="text-center mt-2 mb-8">Widget Created!</h3>               
      </div>
      <div v-else class="text-center mt-2 mb-8">
        <h3>Widget Installation</h3>
        </div>
              
      <div v-if="currentInstallWidgetData.type === 'wallofproof'">        
              
        <p class="my-4 font-medium"><span class="font-semibold">Step 1. </span>Copy and paste the below code snippet  <span class="font-semibold">right before the &lt;/body&gt; tag</span> in all HTML pages where you want to display your widget.</p>
        <div class="vx-card p-0">
          <div class="text-dark px-3 py-5 rounded italic w-full">
          <pre :id="`${currentInstallWidgetData.widgetID}code`" class="w-full bg-white block overflow-x-scroll p-0" >&lt;script&gt;
  //Feedback Link Showcase Widget "{{ currentInstallWidgetData.name }}":
  ! function(w, d){
    if (!w || !d) return false    
    d.addEventListener("DOMContentLoaded", function(event) {
        var s = d.createElement('script');
        s.setAttribute('src','https://fbl.embedwidgets.com/{{
              currentInstallWidgetData.widgetID
            }}.js');
        d.body.appendChild(s);
      });
    }(window, document)
 &lt;/script&gt;</pre>      
        </div>        
        </div>
        <vs-button @click="copyCode(currentInstallWidgetData.widgetID, 'code')" type="border" class="w-full" icon-pack="feather" :icon="lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}code` ? '' : 'icon-copy'" icon-after>{{ lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}code` ? 'Copied!' : 'Copy' }}</vs-button>        
        <p class="mt-4 text-light">Remember to place this script <span class="font-bold">right above</span> the &lt;/body&gt; tag.</p>        
        <p class="my-4 font-medium"><span class="font-semibold">Step 2. </span>Copy and paste the below code snippet at the <span class="font-semibold">exact position</span> where you want your Wall of Proof to be displayed.</p>        
        <div class="vx-card p-0">
          <div class="text-dark px-3 py-5 rounded italic w-full">
          <pre :id="`${currentInstallWidgetData.widgetID}div`" class="w-full bg-white block overflow-x-scroll p-0">&lt;div class="fbl_w_{{currentInstallWidgetData.widgetID}}"&gt;&lt;/div&gt;</pre>          
        </div>        
        </div>
        <vs-button @click="copyCode(currentInstallWidgetData.widgetID, 'div')" type="border" class="w-full" icon-pack="feather" :icon="lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}div` ? '' : 'icon-copy'" icon-after>{{ lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}div` ? 'Copied!' : 'Copy' }}</vs-button>        
        <p class="my-4 font-medium">You can place more than one of these snippets anywhere on the page. The Wall of Proof will be loaded in those position(s).</p>      
      </div>
      <div v-else>

        <p class="my-4 font-medium">Copy and paste the below code snippet anywhere before the &lt;/body&gt; tag in all HTML pages where you want the widget to be displayed.</p>
        <div class="vx-card">
        <div class="text-dark px-5 py-3 rounded w-full">
          <pre :id="`${currentInstallWidgetData.widgetID}code`" class="w-full bg-white block overflow-x-scroll">&lt;script&gt;
  //Feedback Link Showcase Widget "{{ currentInstallWidgetData.name }}":
  ! function(w, d){
    if (!w || !d) return false
    d.addEventListener("DOMContentLoaded", function(event) {
        var s = d.createElement('script');
        s.setAttribute('src','https://fbl.embedwidgets.com/{{
              currentInstallWidgetData.widgetID
            }}.js')
        d.body.appendChild(s);
    });
    }(window, document);
 &lt;/script&gt;</pre>
        </div>
        </div>      
        <vs-button @click="copyCode(currentInstallWidgetData.widgetID, 'code')" type="border" class="w-full" icon-pack="feather" :icon="lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}code` ? '' : 'icon-copy'" icon-after>{{ lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}code` ? 'Copied!' : 'Copy' }}</vs-button>        
      </div>
      <div class="flex justify-end pt-4">
        <vs-button
          class="ml-1 px-32"
          @click="
            () => {
              showSideSlide = false
              $router.replace('/dash/showcase');
            }
          "
          >Ok</vs-button
        >
      </div>
    </vs-popup>

*/







/*

NB!!!

//if domain settings needs to be updated, 
//remember to only upate the [0] element on entity.showcase

*/


import DomainSettings from './Components/DomainSettings.vue'
import ShowcasedRowControls from './Components/ShowcasedRowControls.vue'
import Savebutton from "../components/ptcomponents/Savebutton.vue";
import Pagesubtitle from "../components/ptcomponents/Pagesubtitle.vue";
import SideSlide from "../components/ptcomponents/sideslide/SideSlide.vue";
import Showcase from "../components/ptcomponents/Showcase.vue";
import ImportReviewsModal from "../components/ImportReviewsModal.vue";
import ImportReviewsAlert from "../components/ImportReviewsAlert.vue";
import StarRating from 'vue-star-rating'
import VueLoadImage from 'vue-load-image'
import HLSVideoPlayer from '../components/ptcomponents/hlsvideoplayer/HLSVideoPlayer.vue'

const PLATFORM_NAMES = {
  gp: 'Google', fb: 'Facebook', tp: 'Trustpilot', ta: 'TripAdvisor',
  ye: 'Yelp', ca: 'Capterra', g2: 'G2', fs: 'Foursquare',
  feedback: 'Feedback', testimonial: 'Testimonial'
}
// Static require map so webpack bundles exactly these 8 files. Don't use
// require(`@/assets/images/logo/${file}`) — that creates a context module
// that scans the entire logo dir (including favicon.ico binary, which
// webpack can't parse).
const PLATFORM_LOGOS = {
  gp: require('@/assets/images/logo/gp.png'),
  fb: require('@/assets/images/logo/fb.png'),
  tp: require('@/assets/images/logo/tp.png'),
  ta: require('@/assets/images/logo/ta.png'),
  ye: require('@/assets/images/logo/ye.png'),
  ca: require('@/assets/images/logo/ca.png'),
  g2: require('@/assets/images/logo/gc.png'),
  fs: require('@/assets/images/logo/fs.png')
}

export default {
  computed: {
    widgetsLoading() {
      return this.$store.state.dash.viewData.buildWidgetsTimeout
    },
    showcasedItems() {
      const items = this.$store.state.dash.viewData.showcasedItems || []
      return [...items].sort((a, b) => (b.dateModified || 0) - (a.dateModified || 0))
    },
  },
  data() {
    return {
      lastCopiedToClipboard: false, //wIDcode or wIDdiv
      domainSettings: {
        domainBase: '',
        subs: []
      },
      currentTab: 0,
      showSideSlide: false,    
      iframeSrc: '',
      lastWidgetId: null,
    lastWidgetType: null,
    lastWidgetName: null,
      showPreviewWidget: false,
      // "See example" slide-out — shows the same hosted demo as the marketing homepage.
      showExampleWidget: false,
      exampleIframeSrc: '',
      currentInstallWidgetData: false,
      timeSCreated: Math.floor(new Date().getTime() / 1000),
      uniquePopupID: Math.floor(new Date().getTime() / 1000),
      //
      showSureRemoveWidget: false,
      currentWidgetToRemoveID: false,
      currentWidgetToRemoveName: false,
      removeText: '',
      // Toggled from the "Import Reviews" button on the On Showcase tab.
      // Owned by Showcase22 so the button can open it via v-model; all modal
      // internals (extension handshake, status banner, etc.) live inside
      // ImportReviewsModal.vue.
      showAddMoreModal: false,
      // "How does this work?" → opens ImportReviewsAlert hero inside vs-popup.
      showExplainerModal: false
    }
  },
  components: {
    Pagesubtitle,
    Savebutton,
    DomainSettings,
    SideSlide,
    Showcase,
    ShowcasedRowControls,
    ImportReviewsModal,
    ImportReviewsAlert,
    StarRating,
    HLSVideoPlayer,
    'vue-load-image': VueLoadImage
  },
  created() {
    //do we need to show install instructions?
     this.checkShowWidgetInstall()

     if (!this.$store.state.dash.viewState.showcasedItemsLoaded) {
       this.$store.dispatch('dash/FETCH_SHOWCASED_ITEMS').catch((e) => {
         console.log('FETCH_SHOWCASED_ITEMS failed', e)
       })
     }

    // Refetch when user comes back to this tab — typically after capturing a
    // review in the extension on another tab. 3s guard prevents quick
    // tab-switches from hammering the backend.
    this._lastVisibilityFetch = Date.now()
    this._onVisibilityChange = () => {
      if (document.visibilityState !== 'visible') return
      if (Date.now() - this._lastVisibilityFetch < 3000) return
      this._lastVisibilityFetch = Date.now()
      this.$store.dispatch('dash/FETCH_SHOWCASED_ITEMS').catch((e) => {
        console.log('FETCH_SHOWCASED_ITEMS (visibility) failed', e)
      })
    }
    document.addEventListener('visibilitychange', this._onVisibilityChange)
  },
  watch: {
    '$route'() {
      this.checkShowWidgetInstall()
    }
  },
  beforeDestroy() {
    if (this._onVisibilityChange) {
      document.removeEventListener('visibilitychange', this._onVisibilityChange)
    }
  },
  methods: {
    platformName(pf) {
      return PLATFORM_NAMES[pf] || pf
    },
    platformIcon(pf) {
      return PLATFORM_LOGOS[pf] || null
    },
    itemView(item) {
      const d = item.data || {}
      const rating = d.rating || d.rating_value || d.review_rating || null
      const ratingMax = d.rating_max || d.review_rating_max || 5
      let dateDisplay = d.date || ''
      if (!dateDisplay && item.dateModified) {
        try {
          dateDisplay = new Date(item.dateModified * 1000).toLocaleDateString()
        } catch (e) { dateDisplay = '' }
      }
      // For feedback/testimonial steps, `answer` is an object ({ textAnswer, videoURLAnswer,
      // name, profilePicture, ... }) or an array (multi-select). Reviews use plain string body
      // fields. `ans` is the answer object when present; reviews leave it null.
      const ans = (d.answer && typeof d.answer === 'object' && !Array.isArray(d.answer)) ? d.answer : null
      // Normalise body to a string so the template never renders raw JSON like
      // { "videoURLAnswer": false, "textAnswer": "..." }.
      let body = d.body || d.review_text || d.response || ''
      if (!body && d.answer != null) {
        const a = d.answer
        if (Array.isArray(a)) body = a.join(', ')
        else if (ans) body = ans.textAnswer || ''
        else body = a
      }
      return {
        // Testimonial steps carry the reviewer's name/photo inside the answer object.
        author: d.author || d.name || d.reviewer_name || (ans && ans.name) || 'Anonymous',
        dateDisplay,
        rating: rating ? Number(rating) : null,
        ratingMax: Number(ratingMax) || 5,
        title: d.title || d.review_title || '',
        body,
        profilePic: d.profile_picture || (ans && ans.profilePicture) || null,
        sourceUrl: d.sourceUrl || d.url || d.sourceUrlOriginal || null,
        // Video testimonials carry the playable HLS URL + Cloudflare Stream UID
        // inside the answer object (same shape as /dash/responses). `answer` is
        // passed straight to downloadVideo, which needs videoURLAnswer + streamUID.
        videoURL: (ans && ans.videoURLAnswer) || null,
        streamUID: (ans && ans.streamUID) || null,
        videoThumbURL: (ans && ans.videoThumbURL) || null,
        answer: ans,
      }
    },
    // Mirrors Allfeedback.vue: migrated videos serve from R2 (.mp4); the legacy
    // Cloudflare downloads URL 404s once the Stream original is deleted, so open
    // the R2 URL directly when present.
    downloadVideo(answer) {
      if (!answer) return
      const streamUID = answer.streamUID
      const url = (answer.videoURLAnswer || '').endsWith('.mp4')
        ? answer.videoURLAnswer
        : `https://customer-n548bbvvl783tp8n.cloudflarestream.com/${streamUID}/downloads/default.mp4?filename=video_${streamUID.substr(0, 5)}.mp4`
      window.open(url, '_blank')
    },
    // A showcased item shows on widget W iff
    //   W.showAllTags === true  OR  W.showOnlyTags ∩ item.taggedWith ≠ ∅
    // Source: Backend/Cloud Run Services/reviewsAndShowcase/sharedMethods/widgetMethods.js
    // and the client-side filter inside the widget bundle itself.
    matchedWidgetsFor(item) {
      const widgets = this.$store.state.dash.viewData.currentWidgets || []
      const itemTags = (item && item.taggedWith) || []
      return widgets.filter(w => {
        if (w.showAllTags === true) return true
        const onlyTags = w.showOnlyTags || []
        if (onlyTags.length === 0) return false
        return onlyTags.some(t => itemTags.indexOf(t) !== -1)
      })
    },
    buildShowcasePayload(item) {
      const isFeedbackTesto = item.platform === 'feedback' || item.platform === 'testimonial'
      if (isFeedbackTesto) {
        const lastUnderscore = item.id.lastIndexOf('_')
        const sessionID = lastUnderscore > -1 ? item.id.slice(0, lastUnderscore) : item.id
        const i = lastUnderscore > -1 ? Number(item.id.slice(lastUnderscore + 1)) : 0
        return {
          data: { platform: item.platform, i, sessionID },
          method: this.toggleShowcaseFromTab
        }
      }
      return {
        data: { platform: item.platform, i: 0, reviewDocID: item.id },
        method: this.toggleShowcaseFromTab
      }
    },
    toggleShowcaseFromTab(pf, i, ref, tag, intent, currentTags) {
      const isFeedbackTesto = pf === 'feedback' || pf === 'testimonial'
      const id = isFeedbackTesto ? `${ref}_${i}` : ref
      const item = this.$store.state.dash.viewData.showcasedItems.find(it => it.id === id)
      if (!item) {
        console.warn('Showcased item not found locally:', id)
        return
      }

      // Optimistic update of currentShowcasedIDs so /dash/responses stays in sync.
      this.$store.commit('dash/MARK_SHOWCASE_ITEM', {
        jFI: isFeedbackTesto ? i : null,
        rvwOrSnID: isFeedbackTesto ? ref : id,
        type: isFeedbackTesto ? pf : 'review',
        tag,
        intent
      })

      this.$store.dispatch('dash/TOGGLE_MARK_SHOWCASE_FROM_TAB', {
        item, intent, tag, currentTags
      }).then(() => {
        // Refetch hydrated list so taggedWith stays accurate and deletions disappear.
        this.$store.dispatch('dash/FETCH_SHOWCASED_ITEMS').catch((e) => {
          console.log('refetch after toggle failed', e)
        })
        this.$vs.notify({
          title: intent ? 'Showcase updated' : 'Showcase updated',
          text: !tag && !intent ? 'Removed item from showcase' : (tag ? (intent ? `Added tag "${tag}"` : `Removed tag "${tag}"`) : 'Showcase updated'),
          color: 'success',
          time: 4000,
          iconPack: 'feather',
          icon: 'icon-check'
        })
      }).catch((e) => {
        console.log(e)
        // Roll back optimistic update.
        this.$store.commit('dash/MARK_SHOWCASE_ITEM', {
          jFI: isFeedbackTesto ? i : null,
          rvwOrSnID: isFeedbackTesto ? ref : id,
          type: isFeedbackTesto ? pf : 'review',
          tag,
          intent: !intent
        })
        this.$vs.notify({
          title: 'Showcase',
          text: 'Something went wrong updating your showcase. Please try again or contact support.',
          color: 'warning',
          time: 10000,
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      })
    },
    optAddMore() {
      // ImportReviewsModal watches its `value` prop and runs the extension
      // handshake on open — we only need to flip the flag here.
      this.showAddMoreModal = true
    },
    onExplainerInstallClick(val) {
      // User clicked "Import Reviews" inside the explainer modal — close the
      // explainer and open the actual install flow.
      if (val) {
        this.showExplainerModal = false
        this.showAddMoreModal = true
      }
    },
    generateScriptTag(wID, widgetName) {
  // ?t=${Date.now()} busts the browser's own cache so the Refresh button reloads
  // the JS on each click. Edge freshness is handled separately by the buildWidget
  // Cloud Function calling Cloudflare's purge_cache API after each rebuild.
  return `<script>! function(w, d){if (!w || !d) return false; d.addEventListener("DOMContentLoaded", function(event) { var s = d.createElement('script'); s.setAttribute('src','https://fbl.embedwidgets.com/${wID}.js?t=${Date.now()}'); d.body.appendChild(s); });}(window, document);${'</'}script>`;
},
refreshFrame() {
    // call previewWidget again with the last used parameters
    if (this.lastWidgetId && this.lastWidgetType && this.lastWidgetName) {
      this.previewWidget(this.lastWidgetId, this.lastWidgetType, this.lastWidgetName);
    }
  },
// Open the generic, hosted demo for a widget type — the same example drawer
// shown on the marketing homepage. Reuses the prod example pages so it works
// from any dashboard mode (serve/devcloud/prod).
seeExample(widgetType) {
  const examples = {
    wallofproof: 'https://feedback.link/wopexample.html',
    generalnudge: 'https://feedback.link/nudgeexample.html',
    carousel: 'https://feedback.link/carouselexample.html',
    infinitywall: 'https://feedback.link/infinitywallexample.html',
  };
  this.exampleIframeSrc = examples[widgetType] || '';
  this.showExampleWidget = true;
},
previewWidget(wID, widgetType, widgetName) {

  this.showPreviewWidget = true;

  this.lastWidgetId = wID;
  this.lastWidgetType = widgetType;
  this.lastWidgetName = widgetName;

  setTimeout(() => {
    const iframe = this.$refs.widgetpreviewframe;
  let doc = iframe.contentWindow || iframe.contentDocument;

  if (doc.document) {
    doc = doc.document;
  }

  let scriptTag = this.generateScriptTag(wID, widgetName);

  let bodyContent = '';
  if (widgetType === 'wallofproof' || widgetType === 'carousel' || widgetType === 'infinitywall') {

    // Add low-fidelity mockup blocks
  bodyContent += `
    <div style="padding: 0 5%; box-sizing: border-box;">
    <div style="border-radius: 8px; background-color: #F1F1F1; width: 100%; height: 50px; margin-bottom: 2%; box-sizing: border-box; padding-left: 10px; line-height: 50px; color: gray; font-family: sans-serif;">YOUR WEBSITE</div>
    <div class="fbl_w_${wID}"></div>
    </div>`;
  } else {
  // Add low-fidelity mockup blocks
  bodyContent += `
    <div style="padding: 0 5%; box-sizing: border-box;">
    <div style="border-radius: 8px; background-color: #F1F1F1; width: 100%; height: 50px; margin-bottom: 1%; box-sizing: border-box; padding-left: 10px; line-height: 50px; color: gray; font-family: sans-serif;">
      YOUR WEBSITE
    </div>
    <p style="color: gray; font-family: sans-serif; font-size: 14px;">(Your nudge will show in a moment in a bottom corner...)</p>
    <div style="display: flex; justify-content: space-between;">
      <div style="border-radius: 8px; background-color: #F1F1F1; width: 32.3%; height: 1000px; margin-bottom: 5%; "></div>
      <div style="border-radius: 8px; background-color: #F1F1F1; width: 32.3%; height: 1000px; margin-bottom: 5%;"></div>
      <div style="border-radius: 8px; background-color: #F1F1F1; width: 32.3%; height: 1000px; margin-bottom: 5%;"></div>
    </div>
    <style>body{overflow: hidden;}</style>
    </div>`;
  
  }


  let htmlContent = `<!DOCTYPE html><html><head><title>Your Title</title>${widgetType === 'wallofproof' || widgetType === 'carousel' || widgetType === 'infinitywall' ? scriptTag : ''}</head><body>${widgetType === 'generalnudge' ? scriptTag : ''}${bodyContent}</body></html>`;

  doc.open();
  doc.write(htmlContent);
  doc.close();
  },10)

},

    copyCode(wID, codeOrDiv) {

      try {
        this.copyTextToClipboard(document.getElementById(`${wID}${codeOrDiv}`).textContent)
        this.lastCopiedToClipboard = `${wID}${codeOrDiv}`
      } catch (e) {
        console.log(e)
      }
      
    },
    updateDomainSettings() {


      //VALIDATION

      let error = false
      if (this.errors.any()) error  = this.errors.all()[0]


      this.domainSettings.domainBase = this.domainSettings.domainBase.trim()

          const dotIndex = this.domainSettings.domainBase.indexOf('.')

          if (
            this.domainSettings.domainBase.length === 0 || 
            dotIndex == 0 || 
            dotIndex == -1 || 
            this.domainSettings.domainBase.length === dotIndex + 1
            ) error = 'We need a valid main domain for where your widgets will be hosted.'


          try {
            const dmn = new URL('https://' + this.domainSettings.domainBase)
          } catch (e){
            error = 'Invalid main domain: We need a valid main domain for where your widgets will be hosted.'
          }          


          const theSubs = [...this.domainSettings.subs]

          theSubs.forEach((sub,i) => {
            if (sub.length === 0) this.domainSettings.subs.splice( i, 1)
          })


      if (error) {
        this.$vs.notify({
            title: '',
            text: error,
            color: 'warning',
            time: 12500,
            iconPack: 'feather',
            icon:'icon-alert-circle'
        }) 
        return  
      } 

            this.$vs.notify({
              title: '',
              text: 'Updating domain settings...',
              color: 'primary',
              time: 1500,
              iconPack: 'feather',
              icon:'icon-info'
          }) 

       this.$store.dispatch('dash/UPDATE_DOMAIN_SETTINGS', this.domainSettings).then(() => {

           this.$vs.notify({
              title: '',
              text: 'Domain settings updated',
              color: 'success',
              time: 10000,
              iconPack: 'feather',
              icon:'icon-check'
            })   

      }).catch(() => {

        this.$vs.notify({
            title: '',
            text: 'Oops! There was a problem while trying to update your settings. Please try again or reach out to support.',
            color: 'warning',
            time: 15000,
            iconPack: 'feather',
            icon:'icon-alert-circle'
        }) 

      })

    },
     domainSettingsUpdated(v) {

      this.domainSettings.subs = [...v.subs.map(itm => itm.text)]
      this.domainSettings.domainBase = v.domainBase

    },
    removeWidget(id) {

        this.$vs.notify({
              title: '',
              text: 'Removing widget...',
              color: 'primary',
              time: 1500,
              iconPack: 'feather',
              icon:'icon-info'
          }) 

       this.$store.dispatch('dash/REMOVE_WIDGET', id).then(() => {

          //resync widget data
          this.$store.dispatch('dash/SYNC_WIDGETS').finally(() => {

            this.$vs.notify({
              title: 'Widget Removed',
              text: 'Widget removed successfully.',
              color: 'success',
              time: 15000,
              iconPack: 'feather',
              icon:'icon-check'
            })           

          })

      }).catch(() => {

        this.$vs.notify({
            title: 'Remove widget',
            text: 'Oops! There was a problem while trying to remove your widget. Please try again or reach out to support.',
            color: 'warning',
            time: 15000,
            iconPack: 'feather',
            icon:'icon-alert-circle'
        }) 

      })



    },
    closeSideSlide() {
      this.showSideSlide = false
      this.$router.replace('/dash/showcase')
    },
    checkShowWidgetInstall() {

      //check if we have widget id in param:

      if (typeof this.$route.params.installwidgetinstructions !== "undefined") {

      const widgetID = this.$route.params.installwidgetinstructions;
      let found = false;

      this.$store.state.dash.viewData.currentWidgets.forEach((w) => {
        if (w.widgetID === widgetID) found = { ...w };
      });

      if (found) {
        this.currentInstallWidgetData = found;
        this.showSideSlide = true;
        this.uniquePopupID = Math.floor(new Date().getTime())
      } else {
        this.$router.replace("/dash/showcase");
      }

      }

    },
    optCreateWidget(type) {
      this.$router.push(`/dash/showcase/setupwidget/${type}`);
    },
  },
};
</script>


<style lang="scss">

// "How to import reviews" explainer — vesta's default popup width is ~500px,
// which crowds the ImportReviewsAlert hero. Widen it while staying responsive.
.import-reviews-explainer-popup .vs-popup {
  width: 90vw;
  max-width: 900px;
}
// On shorter desktops the hero content is taller than the viewport. Cap the
// popup body height and let it scroll instead of overflowing off-screen.
.import-reviews-explainer-popup .vs-popup--content {
  max-height: 80vh;
  overflow-y: auto;
}

.fullscreen-popup .vs-popup {
  width: 95vw; /* 95% of viewport width */
  height: 95vh; /* 95% of viewport height */
  max-width: 95vw; /* to ensure the width does not exceed the viewport width */
  max-height: 95vh; /* to ensure the height does not exceed the viewport height */
}


iframe.wpreview {
  outline: none;
  border: none;
}

// Video testimonials on the On Showcase tab — same rounded styling as
// /dash/responses, but sized to fill the card column (video.js otherwise
// falls back to its default 300x150).
.showcased-video {
  > div {
    .vjs-control-bar {
      border-radius: 0 0 10px 10px;
    }
    .video-js {
      width: 100%;
      height: auto;
      aspect-ratio: 16 / 9;
      border-radius: 10px !important;
      video {
        border-radius: 10px !important;
      }
    }
  }
}

</style>
